<template>
  <div class="data-table-container" id="data-table-container">
    <!-- 搜索、筛选和工具栏 -->
    <div class="toolbar-container" id="toolbar-container">
      <div class="toolbar">
        <el-button type="primary" @click="showAddDialog">新增</el-button>
        <el-button type="danger" @click="handleBatchDelete">删除</el-button>
        <el-button type="success" @click="showExportOptions">导出</el-button>
        <!-- 新增：设置背景颜色按钮和下拉菜单 -->
        <el-dropdown @command="setBackgroundColor" trigger="click">
          <el-button type="warning">
            设置标注 <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="option in colorOptions" :key="option.value" :command="option.value" :style="{ backgroundColor: option.value || 'transparent' }">
              {{ option.label }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- 同步订单按钮 -->
        <el-button type="info" @click="syncOrders" :loading="isSyncing">同步 {{ storeName }} 订单</el-button>
        <el-input
          v-model="searchForm.number"
          placeholder="搜索内容"
          style="width: 150px;"
          @keyup.enter.native="fetchData"
        ></el-input>
        <!-- 新增：搜索字段选择 -->
        <el-select v-model="searchForm.searchField" placeholder="搜索字段" style="width: 120px; margin-right: 10px;">
          <el-option label="编号" value="number"></el-option>
          <el-option label="修图" value="retouch"></el-option>
          <el-option label="打印" value="print"></el-option>
          <el-option label="制作" value="make"></el-option>
          <el-option label="查验" value="check"></el-option>
          <el-option label="发货" value="ship"></el-option>
          <el-option label="备注" value="remark"></el-option>
        </el-select>
        <el-date-picker
          v-model="searchForm.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          style="width: 240px;"
          :picker-options="pickerOptions"
        ></el-date-picker>
        <el-button type="primary" @click="fetchData">查询</el-button>
        <el-button type="warning" @click="resetSearch">重置搜索</el-button>
        <el-button type="info" @click="fetchData">刷新</el-button>
      </div>
      <div class="filter-container">
        <el-select v-model="filterCondition1" placeholder="快捷筛选1" style="width: 120px; margin-right: 10px;" @change="applyFilter">
          <el-option label="订单类型↓" value="all"></el-option>
          <el-option label="纸海报" value="paperPoster"></el-option>
          <el-option label="加急" value="urgent"></el-option>
          <el-option label="定制" value="custom"></el-option>
          <el-option label="待过" value="pendingRetouch"></el-option>
          <el-option label="暂不发货" value="notShip"></el-option>
          <el-option label="有备注" value="hasRemark"></el-option>
        </el-select>
        <el-select v-model="filterCondition2" placeholder="快捷筛选2" style="width: 120px; margin-right: 10px;" @change="applyFilter">
          <el-option label="生产状态↓" value="all"></el-option>
          <el-option label="未打印" value="notPrinted"></el-option>
          <el-option label="打印未制作" value="printedNotMade"></el-option>
          <el-option label="制作未查验" value="madeNotChecked"></el-option>
          <el-option label="打包未发货" value="checkedNotShipped"></el-option>
        </el-select>
      </div>
    </div>

    <!-- 表格 -->
    <el-table
      ref="dataTable"
      :data="tableData"
      border
      style="width: 100%"
      :row-class-name="tableRowClassName"
      @cell-dblclick="handleCellEdit"
      :key="tableKey"
    >
      <el-table-column
        type="selection"
        min-width="50"
        :resizable="true"
      ></el-table-column>
      <el-table-column prop="time" label="时间" min-width="100" :resizable="true"></el-table-column>
      <el-table-column prop="number" label="编号" min-width="120" :resizable="true"></el-table-column>
      <el-table-column prop="retouch" label="修图" min-width="120" :resizable="true"></el-table-column>
      <el-table-column prop="print" label="打印" min-width="120" :resizable="true"></el-table-column>
      <el-table-column prop="make" label="制作" min-width="120" :resizable="true" show-overflow-tooltip></el-table-column>
      <el-table-column prop="check" label="查验" min-width="120" :resizable="true"></el-table-column>
      <el-table-column prop="ship" label="发货" min-width="100" :resizable="true"></el-table-column>
      <el-table-column
        prop="tracking"
        label="运单号"
        :min-width="trackingColumnWidth"
        :resizable="true"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        :min-width="remarkColumnWidth"
        :resizable="true"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>

    <!-- 分页控件 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 50, 100,200]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 5px; text-align: center;"
      ></el-pagination>
    </div>

    <!-- 新增对话框 -->
    <el-dialog title="批量新增数据" :visible.sync="addDialogVisible" width="30%">
      <el-input
        type="textarea"
        :rows="10"
        placeholder="请输入编号，每行一个编号"
        v-model="batchAddText"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleBatchAdd">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 导出选项对话框 -->
    <el-dialog title="选择导出范围" :visible.sync="exportDialogVisible" width="30%">
      <el-radio-group v-model="exportOption">
        <el-radio label="current">当前页</el-radio>
        <el-radio label="all">全部数据</el-radio>
        <el-radio label="timeRange">按时间范围</el-radio>
        <el-radio label="selected">选中记录</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exportDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="exportToExcel">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from '../utils/api';
import * as XLSX from 'xlsx';
import FileSaver from 'file-saver';

export default {
  props: {
    storePrefix: {
      type: String,
      default: 'all'
    },
    storeName: {
      type: String,
      default: '订单'
    },
    syncApi: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tableData: [],
      searchForm: {
        number: '',
        dateRange: [],
        searchField: 'number'
      },
      addDialogVisible: false,
      batchAddText: '',
      filterCondition1: 'all',
      filterCondition2: 'all',
      pagination: {
        currentPage: 1,
        pageSize: 50,
        total: 0
      },
      exportDialogVisible: false,
      exportOption: 'current',
      autoRefreshInterval: null,
      isEditing: false,
      currentScrollTop: 0,
      currentFirstVisibleRowId: null,
      tableKey: 0,
      editingCell: null,
      isSyncing: false,
      colorOptions: [
        { label: '取消标注', value: '' },
        { label: '加急', value: '#FFFFCC' },
        { label: '有纸海报', value: '#ece2fe' },
        { label: '无画/磁铁背架链接', value: '#7ad3fa' },
        { label: '暂不发货', value: '#f57ac0' },
        { label: '高危订单 取消订单', value: '#FFCCCC' }
      ],
      headerHeight: 80,
      toolbarHeight: 0,
      isToolbarFixed: false,
      toolbarOffsetTop: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          { text: '今天', onClick(picker) { const end = new Date(); const start = new Date(); picker.$emit('pick', [start, end]); } },
          { text: '昨天', onClick(picker) { const end = new Date(); const start = new Date(); start.setTime(start.getTime() - 3600 * 1000 * 24); end.setTime(end.getTime() - 3600 * 1000 * 24); picker.$emit('pick', [start, end]); } },
          { text: '过去7天', onClick(picker) { const end = new Date(); const start = new Date(); start.setTime(start.getTime() - 3600 * 1000 * 24 * 7); picker.$emit('pick', [start, end]); } },
          { text: '过去14天', onClick(picker) { const end = new Date(); const start = new Date(); start.setTime(start.getTime() - 3600 * 1000 * 24 * 14); picker.$emit('pick', [start, end]); } },
          { text: '过去30天', onClick(picker) { const end = new Date(); const start = new Date(); start.setTime(start.getTime() - 3600 * 1000 * 24 * 30); picker.$emit('pick', [start, end]); } },
          { text: '本周', onClick(picker) { const end = new Date(); const start = new Date(); const day = start.getDay(); const diff = day === 0 ? -6 : 1 - day; start.setDate(start.getDate() + diff); picker.$emit('pick', [start, end]); } },
          { text: '上周', onClick(picker) { const end = new Date(); const start = new Date(); const day = start.getDay(); const diffToMonday = day === 0 ? -6 : 1 - day; start.setDate(start.getDate() + diffToMonday - 7); end.setDate(end.getDate() + diffToMonday - 1); picker.$emit('pick', [start, end]); } },
          { text: '本月', onClick(picker) { const end = new Date(); const start = new Date(); start.setDate(1); picker.$emit('pick', [start, end]); } },
          { text: '上个月', onClick(picker) { const end = new Date(); const start = new Date(); start.setMonth(start.getMonth() - 1, 1); end.setMonth(end.getMonth(), 0); picker.$emit('pick', [start, end]); } }
        ]
      }
    };
  },
  computed: {
    trackingColumnWidth() {
      const hasTracking = this.tableData.some(item => item.tracking && item.tracking.trim() !== '');
      return hasTracking ? 150 : 80;
    },
    remarkColumnWidth() {
      const hasRemark = this.tableData.some(item => item.remark && item.remark.trim() !== '');
      return hasRemark ? 200 : 80;
    }
  },
  mounted() {
    this.fetchData();
    this.startAutoRefresh();
    this.$nextTick(() => {
      const tableBody = this.$refs.dataTable.$el.querySelector('.el-table__body-wrapper');
      if (tableBody) {
        tableBody.addEventListener('scroll', this.updateFirstVisibleRow);
      }
      this.updateToolbarInfo();
      window.addEventListener('resize', this.updateToolbarInfo);
      window.addEventListener('scroll', this.handleToolbarScroll);
    });
  },
  beforeDestroy() {
    if (this.autoRefreshInterval) {
      clearInterval(this.autoRefreshInterval);
    }
    const tableBody = this.$refs.dataTable.$el.querySelector('.el-table__body-wrapper');
    if (tableBody) {
      tableBody.removeEventListener('scroll', this.updateFirstVisibleRow);
    }
    window.removeEventListener('resize', this.updateToolbarInfo);
    window.removeEventListener('scroll', this.handleToolbarScroll);
  },
  methods: {
    updateToolbarInfo() {
      const width = window.innerWidth;
      this.headerHeight = width <= 768 ? 60 : 80;
      const toolbar = document.getElementById('toolbar-container');
      if (toolbar) {
        this.toolbarHeight = toolbar.offsetHeight;
        this.toolbarOffsetTop = toolbar.offsetTop;
      }
    },
    handleToolbarScroll() {
      const toolbar = document.getElementById('toolbar-container');
      if (!toolbar) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.toolbarOffsetTop) {
        if (!this.isToolbarFixed) {
          this.isToolbarFixed = true;
          toolbar.style.position = 'fixed';
          toolbar.style.top = `${this.headerHeight}px`;
          toolbar.style.left = '10px';
          toolbar.style.right = '10px';
          toolbar.style.zIndex = '999';
          toolbar.style.backgroundColor = '#fff';
          toolbar.style.padding = '10px';
          toolbar.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
          const table = this.$refs.dataTable.$el;
          if (table) {
            table.style.marginTop = `${this.toolbarHeight + 10}px`;
          }
        }
      } else {
        if (this.isToolbarFixed) {
          this.isToolbarFixed = false;
          toolbar.style.position = '';
          toolbar.style.top = '';
          toolbar.style.left = '';
          toolbar.style.right = '';
          toolbar.style.zIndex = '';
          toolbar.style.boxShadow = '';
          const table = this.$refs.dataTable.$el;
          if (table) {
            table.style.marginTop = '10px';
          }
        }
      }
    },
    updateFirstVisibleRow() {
      const tableBody = this.$refs.dataTable.$el.querySelector('.el-table__body-wrapper');
      if (!tableBody) return;
      const rows = this.$refs.dataTable.$el.querySelectorAll('.el-table__row');
      const scrollTop = tableBody.scrollTop;
      let firstVisibleRow = null;
      for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        const rowTop = row.offsetTop;
        if (rowTop >= scrollTop - 50) {
          const rowIndex = parseInt(row.getAttribute('data-row-index'), 10);
          if (rowIndex >= 0 && rowIndex < this.tableData.length) {
            firstVisibleRow = this.tableData[rowIndex];
          }
          break;
        }
      }
      if (firstVisibleRow) {
        this.currentFirstVisibleRowId = firstVisibleRow.id;
      }
      this.currentScrollTop = scrollTop;
    },
    saveScrollPosition() {
      this.updateFirstVisibleRow();
    },
    restoreScrollPosition() {
      this.$nextTick(() => {
        const tableBody = this.$refs.dataTable.$el.querySelector('.el-table__body-wrapper');
        if (!tableBody) return;
        if (this.currentFirstVisibleRowId) {
          const rowIndex = this.tableData.findIndex(row => row.id === this.currentFirstVisibleRowId);
          if (rowIndex >= 0) {
            const rowElement = this.$refs.dataTable.$el.querySelector(`.el-table__row[data-row-index="${rowIndex}"]`);
            if (rowElement) {
              tableBody.scrollTop = rowElement.offsetTop;
              return;
            }
          }
        }
        tableBody.scrollTop = this.currentScrollTop;
      });
    },
    async fetchData(silent = false) {
      this.saveScrollPosition();
      if (!silent) {
        this.$message.info('正在加载数据...');
      }
      try {
        this.tableData = [];
        const params = {
          number: this.searchForm.number,
          startTime: this.searchForm.dateRange[0] || '',
          endTime: this.searchForm.dateRange[1] || '',
          page: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          filter1: this.filterCondition1,
          filter2: this.filterCondition2,
          searchField: this.searchForm.searchField,
          storePrefix: this.storePrefix
        };
        const res = await api.getData(params);
        let data = [];
        if (res && res.data && res.data.data && Array.isArray(res.data.data)) {
          data = res.data.data;
          this.pagination.total = res.data.pagination.total || 0;
        } else {
          console.error('Unexpected data structure:', res);
          this.$message.error('数据格式错误');
          this.tableData = [];
          return;
        }
        this.tableData = data.map(item => ({
          id: item.ID,
          time: item.时间 ? new Date(item.时间).toLocaleDateString('zh-CN') : '',
          number: item.编号 || '',
          retouch: item.修图 || '',
          print: item.打印 || '',
          make: this.formatMakeColumn(item.制作 || ''),
          check: item.查验 || '',
          ship: item.发货 || '',
          tracking: item.运单号 || '',
          remark: item.备注 || '',
          background_color: item.background_color || ''
        }));
        if (!silent) {
          this.$message.success(`已加载 ${this.tableData.length} 行数据`);
        }
        this.generateBackgroundStyles();
        this.restoreScrollPosition();
      } catch (error) {
        this.$message.error('获取数据失败');
        console.error('Error fetching data:', error);
        this.tableData = [];
      }
    },
    generateBackgroundStyles() {
      const oldStyle = document.querySelector('#dynamic-bg-styles');
      if (oldStyle) {
        oldStyle.remove();
      }
      const style = document.createElement('style');
      style.id = 'dynamic-bg-styles';
      let cssText = '';
      this.tableData.forEach(row => {
        if (row.background_color) {
          cssText += `
            .custom-bg-color-${row.id} {
              background-color: ${row.background_color} !important;
            }
          `;
        }
      });
      style.textContent = cssText;
      document.head.appendChild(style);
    },
    startAutoRefresh() {
      if (this.autoRefreshInterval) {
        clearInterval(this.autoRefreshInterval);
      }
      this.autoRefreshInterval = setInterval(() => {
        if (!this.isEditing) {
          this.fetchData(true);
        }
      }, 300000);
    },
    stopAutoRefresh() {
      if (this.autoRefreshInterval) {
        clearInterval(this.autoRefreshInterval);
        this.autoRefreshInterval = null;
      }
    },
    formatMakeColumn(makeData) {
      if (!makeData) return '';
      const recordRegex = /(\d+✅(?:\s*\d+✅)*)(\s*|\b)(\d{4}-\d{2}-\d{2}|\d{1,2}-\d{1,2})(?:\s*[\d:]*\s*)?([^\d✅]*)/g;
      let matches = [];
      let match;
      while ((match = recordRegex.exec(makeData)) !== null) {
        matches.push({
          text: match[0],
          start: match.index,
          end: match.index + match[0].length,
          numbers: match[1].trim().split(/\s+/).filter(Boolean),
          dateStr: match[3],
          suffix: match[4] || ''
        });
      }
      if (matches.length === 0) {
        return makeData;
      }
      let resultParts = [];
      let lastEnd = 0;
      matches.forEach(m => {
        if (lastEnd < m.start) {
          const invalidPart = makeData.slice(lastEnd, m.start).trim();
          if (invalidPart) {
            resultParts.push({ type: 'invalid', text: invalidPart });
          }
        }
        resultParts.push({ type: 'valid', match: m });
        lastEnd = m.end;
      });
      if (lastEnd < makeData.length) {
        const invalidPart = makeData.slice(lastEnd).trim();
        if (invalidPart) {
          resultParts.push({ type: 'invalid', text: invalidPart });
        }
      }
      const parsedRecords = matches.map(record => {
        let fullDate = record.dateStr;
        let shortDate = record.dateStr;
        if (record.dateStr.match(/^\d{1,2}-\d{1,2}$/)) {
          const [month, day] = record.dateStr.split('-').map(d => d.padStart(2, '0'));
          const dateStr = `${month}-${day}`;
          const currentYear = new Date().getFullYear();
          fullDate = `${currentYear}-${dateStr}`;
          shortDate = dateStr;
        } else {
          shortDate = record.dateStr.split('-').slice(1).join('-');
        }
        const suffixParts = record.suffix.split(/\s+/);
        const namePart = suffixParts.filter(part => !part.match(/^\d+:\d+$/)).join(' ').trim();
        return {
          numbers: record.numbers,
          fullDate: fullDate,
          shortDate: shortDate,
          suffix: record.suffix,
          name: namePart || ''
        };
      });
      const grouped = {};
      parsedRecords.forEach(record => {
        const key = `${record.fullDate}_${record.name}`;
        if (!grouped[key]) {
          grouped[key] = {
            fullDate: record.fullDate,
            shortDate: record.shortDate,
            name: record.name,
            numbers: []
          };
        }
        grouped[key].numbers.push(...record.numbers);
      });
      const sortedGroups = Object.values(grouped).sort((a, b) => new Date(a.fullDate) - new Date(b.fullDate));
      const formattedValid = sortedGroups.map(group => {
        const sortedNumbers = group.numbers.map(num => ({ original: num, value: parseInt(num.replace('✅', '')) })).sort((a, b) => a.value - b.value).map(item => item.original);
        const numbersText = sortedNumbers.join('');
        return `${numbersText} ${group.shortDate} ${group.name}`.trim();
      }).join(' ');
      let finalResult = resultParts.map(part => part.type === 'invalid' ? part.text : '__VALID_PLACEHOLDER__').join(' ');
      if (finalResult.includes('__VALID_PLACEHOLDER__')) {
        finalResult = finalResult.replace('__VALID_PLACEHOLDER__', formattedValid).replace(/ __VALID_PLACEHOLDER__/g, '');
      } else {
        finalResult = finalResult ? `${finalResult} ${formattedValid}` : formattedValid;
      }
      return finalResult;
    },
    resetSearch() {
      this.searchForm.number = '';
      this.searchForm.dateRange = [];
      this.searchForm.searchField = 'number';
      this.filterCondition1 = 'all';
      this.filterCondition2 = 'all';
      this.pagination.currentPage = 1;
      this.fetchData();
    },
    tableRowClassName({ row }) {
      let className = row.isEdited ? 'edited-row excel-row' : 'excel-row';
      if (row.background_color) {
        className += ` custom-bg-color-${row.id}`;
      }
      return className;
    },
    async updateSingleRow(rowId) {
      try {
        const res = await api.getSingleData(rowId);
        if (res && res.data) {
          const item = res.data;
          const updatedRow = {
            id: item.ID,
            time: item.时间 ? new Date(item.时间).toLocaleDateString('zh-CN') : '',
            number: item.编号 || '',
            retouch: item.修图 || '',
            print: item.打印 || '',
            make: this.formatMakeColumn(item.制作 || ''),
            check: item.查验 || '',
            ship: item.发货 || '',
            tracking: item.运单号 || '',
            remark: item.备注 || '',
            background_color: item.background_color || '',
            isEdited: true
          };
          const index = this.tableData.findIndex(row => row.id === rowId);
          if (index !== -1) {
            this.$set(this.tableData, index, updatedRow);
            this.generateBackgroundStyles();
            setTimeout(() => { if (this.tableData[index]) this.tableData[index].isEdited = false; }, 2000);
          }
          return true;
        }
        return false;
      } catch (error) {
        console.error('Error fetching single row:', error);
        return false;
      }
    },
    handleCellEdit(row, column, cell, event) {
      const prop = column.property;
      if (!prop || this.editingCell) return;
      this.saveScrollPosition();
      this.isEditing = true;
      this.stopAutoRefresh();
      this.editingCell = { rowId: row.id, prop, cell, originalValue: row[prop] || '' };
      const input = document.createElement('input');
      input.value = row[prop] || '';
      input.style.width = '98%';
      input.style.height = '22px';
      input.style.background = '#fff';
      input.style.padding = '0 5px';
      input.style.boxSizing = 'border-box';
      input.style.fontSize = '14px';
      cell.innerHTML = '';
      cell.appendChild(input);
      input.focus();
      const saveEdit = async (newValue) => {
        if (newValue !== this.editingCell.originalValue) {
          try {
            await api.updateData(row.id, { [prop]: newValue });
            const success = await this.updateSingleRow(row.id);
            if (!success) await this.fetchData(true);
          } catch (error) {
            console.error('Error updating data:', error);
            await this.fetchData(true);
          }
        }
        cell.innerHTML = newValue || '';
        this.isEditing = false;
        this.editingCell = null;
        this.startAutoRefresh();
        this.restoreScrollPosition();
      };
      input.onblur = () => saveEdit(input.value);
      input.onkeydown = (e) => {
        if (e.key === 'Enter') saveEdit(input.value);
        else if (e.key === 'Escape') {
          cell.innerHTML = this.editingCell.originalValue || '';
          this.isEditing = false;
          this.editingCell = null;
          this.startAutoRefresh();
          this.restoreScrollPosition();
        }
      };
    },
    moveToNextRowEdit(currentRow, column) {
      const currentIndex = this.tableData.findIndex(row => row.id === currentRow.id);
      if (currentIndex < this.tableData.length - 1) {
        const nextRow = this.tableData[currentIndex + 1];
        this.$nextTick(() => {
          const rowElement = this.$refs.dataTable.$el.querySelector(`.el-table__row[data-row-index="${currentIndex + 1}"]`);
          if (rowElement) {
            const cell = rowElement.querySelector(`[data-prop="${column.property}"]`);
            if (cell) this.handleCellEdit(nextRow, column, cell, null);
          }
        });
      }
    },
    showAddDialog() {
      this.batchAddText = '';
      this.addDialogVisible = true;
    },
    async handleBatchAdd() {
      this.saveScrollPosition();
      const lines = this.batchAddText.split('\n').filter(line => line.trim());
      if (lines.length === 0) {
        this.$message.warning('请输入至少一个编号');
        return;
      }
      const data = lines.map(line => {
        const number = line.trim().split(',')[0].trim();
        const currentDate = new Date().toISOString().split('T')[0];
        return { time: currentDate, number, retouch: '未开始', print: '未开始', make: '未开始', check: '未开始', ship: '未处理', tracking: '', background_color: '', remark: '' };
      });
      try {
        await api.addData(data);
        this.addDialogVisible = false;
        this.$message.success('批量新增成功');
        await this.fetchData();
      } catch (error) {
        this.$message.error('批量新增失败: ' + (error.response?.data?.message || error.message));
      }
      this.restoreScrollPosition();
    },
    async handleBatchDelete() {
      this.saveScrollPosition();
      const selected = this.$refs.dataTable.selection;
      if (selected.length === 0) {
        this.$message.warning('请选择要删除的行');
        return;
      }
      const ids = selected.map(row => row.id);
      try {
        await api.deleteData(ids);
        this.$message.success('删除成功');
        await this.fetchData();
      } catch (error) {
        this.$message.error('删除失败');
      }
      this.restoreScrollPosition();
    },
    handleSizeChange(val) {
      this.saveScrollPosition();
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.saveScrollPosition();
      this.pagination.currentPage = val;
      this.fetchData();
    },
    applyFilter() {
      this.saveScrollPosition();
      this.pagination.currentPage = 1;
      this.fetchData();
    },
    showExportOptions() {
      if (this.tableData.length === 0) {
        this.$message.warning('当前没有数据可导出');
        return;
      }
      this.exportDialogVisible = true;
    },
    async exportToExcel() {
      this.exportDialogVisible = false;
      let exportData = [];
      let fileName = 'export_data.xlsx';
      if (this.exportOption === 'current') {
        exportData = this.tableData;
        fileName = 'export_current_page.xlsx';
      } else if (this.exportOption === 'all' || this.exportOption === 'timeRange') {
        let params = { page: 1, pageSize: 1000000 };
        if (this.exportOption === 'all') {
          params = { ...params, number: this.searchForm.number, startTime: this.searchForm.dateRange[0] || '', endTime: this.searchForm.dateRange[1] || '', filter1: this.filterCondition1, filter2: this.filterCondition2 };
          fileName = 'export_all_data.xlsx';
        } else {
          if (!this.searchForm.dateRange || this.searchForm.dateRange.length !== 2) {
            this.$message.warning('请选择时间范围后再导出');
            return;
          }
          params = { ...params, startTime: this.searchForm.dateRange[0], endTime: this.searchForm.dateRange[1] };
          fileName = `export_time_range_${params.startTime}_to_${params.endTime}.xlsx`;
        }
        try {
          const res = await api.getData(params);
          if (res && res.data && res.data.data) {
            exportData = res.data.data.map(item => ({ id: item.ID, time: item.时间 ? new Date(item.时间).toLocaleDateString('zh-CN') : '', number: item.编号, retouch: item.修图, print: item.打印, make: this.formatMakeColumn(item.制作), check: item.查验, ship: item.发货, tracking: item.运单号, remark: item.备注 }));
          } else {
            this.$message.error('获取导出数据失败');
            return;
          }
        } catch (error) {
          this.$message.error('导出数据失败');
          return;
        }
      } else if (this.exportOption === 'selected') {
        exportData = this.$refs.dataTable.selection;
        if (exportData.length === 0) {
          this.$message.warning('请选择要导出的记录');
          return;
        }
        fileName = 'export_selected_data.xlsx';
      }
      this.exportExcelData(exportData, fileName);
      this.$message.success('数据已开始导出');
    },
    exportExcelData(data, fileName) {
      const exportData = data.map(item => ({ '时间': item.time, '编号': item.number, '修图': item.retouch, '打印': item.print, '制作': item.make, '查验': item.check, '发货': item.ship, '运单号': item.tracking, '备注': item.remark }));
      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      FileSaver.saveAs(new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), fileName);
    },
    async setBackgroundColor(color) {
      const selected = this.$refs.dataTable.selection;
      if (selected.length === 0) {
        this.$message.warning('请选择至少一条记录');
        return;
      }
      try {
        for (const row of selected) {
          await api.updateData(row.id, { background_color: color });
          row.background_color = color;
        }
        this.generateBackgroundStyles();
        this.$message.success(`已为 ${selected.length} 条记录设置标注`);
      } catch (error) {
        this.$message.error('设置标注失败');
      }
    },
    // 通用同步订单方法
    async syncOrders() {
      if (!this.syncApi) {
        this.$message.warning('未配置同步API');
        return;
      }
      if (this.isSyncing) {
        this.$message.warning('同步操作正在进行中，请稍候...');
        return;
      }
      this.isSyncing = true;
      this.$message.info(`正在同步 ${this.storeName} 订单，请打开浏览器控制台查看详细日志...`);
      console.log(`%c--- 前端：开始发起同步 ${this.storeName} 订单请求 ---`, "color: blue; font-weight: bold;");
      
      try {
        // 动态调用 API
        const response = await api[this.syncApi]();
        
        if (response && response.data && response.data.debugLogs && response.data.debugLogs.length > 0) {
          console.group('【后端返回的执行日志】');
          response.data.debugLogs.forEach(log => console.log(log));
          console.groupEnd();
        }
        console.log("%c--- 前端：同步完成 ---", "color: blue; font-weight: bold;");
        
        if (response && response.data) {
          console.log('后端返回的消息:', response.data.message);
          console.log('新增订单数量:', response.data.inserted);
          this.$message.success(`${this.storeName} 同步成功，共新增 ${response.data.inserted} 条订单`);
          await this.fetchData();
        } else {
          console.error('前端：响应数据格式错误', response);
          this.$message.error(`${this.storeName} 同步失败：响应数据格式错误`);
        }
      } catch (error) {
        console.error('前端：同步请求失败!', error);
        if (error.response && error.response.data && error.response.data.debugLogs) {
          console.group('【后端返回的错误日志】');
          error.response.data.debugLogs.forEach(log => console.log(log));
          console.groupEnd();
        }
        const errorMessage = (error.response && error.response.data.message) || '发生未知错误';
        this.$message.error(`同步 ${this.storeName} 订单失败: ` + errorMessage);
      } finally {
        this.isSyncing = false;
      }
    }
  }
};
</script>

<style scoped>
.data-table-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  overflow-y: auto;
}
.toolbar-container {
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  background-color: #fff;
  padding: 10px;
  transition: all 0.3s ease;
}
.toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: nowrap;
}
.filter-container {
  display: flex;
  align-items: center;
}
.el-table {
  flex: 1;
  overflow: auto;
  width: 100%;
  margin-top: 10px;
  transition: margin-top 0.3s ease;
}
.el-table__body-wrapper {
  height: calc(100vh - 200px);
  overflow-y: auto;
}
.pagination-container {
  margin-top: 5px;
  display: flex;
  justify-content: center;
}
.excel-row {
  height: 30px;
  line-height: 30px;
}
.el-table td, .el-table th {
  padding: 0;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-table th {
  height: 30px;
  line-height: 30px;
}
.edited-row {
  background-color: #e6f7ff !important;
  transition: background-color 0.5s ease;
}

/* 响应式调整：手机端工具栏样式 */
@media screen and (max-width: 768px) {
  .toolbar {
    flex-wrap: wrap;
  }
  .toolbar-container {
    padding: 5px;
    left: 5px;
    right: 5px;
  }
  .el-button, .el-input, .el-select, .el-date-picker {
    margin-bottom: 5px;
  }
  .el-table {
    margin-top: 10px;
  }
  .el-table__body-wrapper {
    height: calc(100vh - 180px);
  }
}
</style>